import BBCodeText from '../../../plugins/gameobjects/text/bbocdetext/BBCodeText.js';
export default BBCodeText;